module.exports = __webpack_public_path__ + "img/cgd7.baa5ee39.jpg";